export class KeyNotExistsError extends Error {
	public static readonly keyNotExistsText = "The key not exists on item";

	constructor(public key: string, message: string) {
		super(`${message}:${key}`);
		Object.setPrototypeOf(this, KeyNotExistsError.prototype);
	}
}